import { Roles } from '@shs-digi-care-monorepo/interfaces';
import { Stage } from '@shs-digi-care-monorepo/frontend-lib/enums';

/**
 * All role-gated features in the NAM module.
 * Add new entries here when introducing new role- or stage-specific features.
 */
export enum NamFeature {
    /** Access to the admin area as a whole */
    ADMIN_AREA = 'ADMIN_AREA',
    /** Task list holding every request of the stream */
    ALL_REQUESTS = 'ALL_REQUESTS',
    /** Reagent order tiles linking into the IRO application */
    REAGENT_ORDERS = 'REAGENT_ORDERS',
    /** Allocation request form */
    ALLOCATION = 'ALLOCATION',
    /** Saturday Delivery request type */
    SATURDAY_DELIVERY = 'SATURDAY_DELIVERY',
    /** Material and Pricing request type */
    MATERIAL_AND_PRICING = 'MATERIAL_AND_PRICING',
    /** Profile details tab in the user settings */
    PROFILE_DETAILS = 'PROFILE_DETAILS',
    /** User settings tab in the user settings */
    USER_SETTINGS = 'USER_SETTINGS',
    /** Application settings tab in the user settings */
    APPLICATION_SETTINGS = 'APPLICATION_SETTINGS',
    /** Maintaining one's own absences */
    OUT_OF_OFFICE = 'OUT_OF_OFFICE',
    /** Out-of-office calendar across the teams in scope */
    OUT_OF_OFFICE_CALENDAR = 'OUT_OF_OFFICE_CALENDAR'
}

/**
 * Feature configuration entry defining which roles can access a feature.
 */
export interface FeatureConfig {
    /** Roles that have access to this feature. Empty array means all roles have access. */
    roles: Roles[];
    /** Optional: users flagged as Siemens internal get access regardless of their roles. */
    includeInternalUsers?: boolean;
    /** Optional: feature is disabled on these stages */
    disabledOnStages?: Stage[];
}
